var ApplicationBaseComponent_1;
import { __decorate } from "tslib";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../services/route-params.service";
import { AflaModuleStrategyService } from "../../services/afla-module-strategy/afla-module-strategy.service";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { Subject } from "rxjs";
let ApplicationBaseComponent = class ApplicationBaseComponent {
    static { ApplicationBaseComponent_1 = this; }
    route;
    routerParamsService;
    aflaModuleStrategyService;
    _destroy$ = new Subject();
    jobID = null;
    moduleID = null;
    routerParamsSubscription;
    constructor(route, routerParamsService, aflaModuleStrategyService) {
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
    }
    static checkIfChanged(newValue, oldValue) {
        if (!newValue) {
            throw new Error("Value must exist");
        }
        return newValue !== oldValue;
    }
    listenForRouteParamChange() {
        this.routerParamsSubscription = this.routerParamsService.params.subscribe((params) => {
            this.handleRouteParamChange(params);
        });
    }
    handleRouteParamChange(params) {
        if (params.moduleid || params.jobID) {
            const jobid = params.jobID ? params.jobID : "-1";
            const moduleid = params.moduleid ? params.moduleid : "-1";
            if (ApplicationBaseComponent_1.checkIfChanged(jobid, this.jobID)
                || ApplicationBaseComponent_1.checkIfChanged(moduleid, this.moduleID)) {
                this.moduleID = moduleid;
                this.jobID = jobid;
                this.handleRouteChange();
            }
        }
    }
    static ctorParameters = () => [
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AflaModuleStrategyService }
    ];
};
ApplicationBaseComponent = ApplicationBaseComponent_1 = __decorate([
    Component({
        standalone: false,
        template: "",
        changeDetection: ChangeDetectionStrategy.OnPush,
        host: { "ApplicationBaseComponent": "application" }
    }),
    AutoUnsub()
], ApplicationBaseComponent);
export { ApplicationBaseComponent };
